<div class="mbm-tabs" [class.mbm-tabs-segment]="variant() === 'segment'" role="tablist">
  @for (tab of tabs(); track tab.id) {
    <button type="button" role="tab" class="mbm-tab"
      [class.mbm-tab-active]="selectedTabId() === tab.id"
      [attr.aria-selected]="selectedTabId() === tab.id"
      [attr.data-tab-id]="tab.id"
      (click)="selectTab(tab.id)">
      <span class="mbm-tab-label">{{ tab.label ?? (tab.labelKey! | translate) }}@if (tab.suffix) {<span class="mbm-tab-suffix">&nbsp;{{ tab.suffix }}</span>}</span>
    </button>
  }
</div>
